import {
  DATE_RANGE_TYPES,
  getActiveDateRange,
} from 'dashboard/components/ui/DatePicker/helpers/DatePickerHelper';

// Report filters live in the tab's session instead of the URL. The address bar stays a plain link
// to the screen, and the range, the business-hours toggle and the inbox/agent selection survive a
// reload and follow the user from one report tab to the next.
const storageKey = accountId => `reports_filters_${accountId}`;

export const readReportFilters = accountId => {
  try {
    return JSON.parse(sessionStorage.getItem(storageKey(accountId))) || {};
  } catch {
    return {};
  }
};

export const writeReportFilters = (accountId, filters) => {
  sessionStorage.setItem(
    storageKey(accountId),
    JSON.stringify({ ...readReportFilters(accountId), ...filters })
  );
};

// The dates to show for what was stored, or null when nothing was. A preset like "last 7 days" is
// relative to today, so its dates are worked out again rather than restored - a tab left open
// overnight would otherwise keep yesterday's window under the same label. Only a custom range is
// the dates themselves.
export const restoredDateRange = ({ range, from, to }) => {
  if (range && range !== DATE_RANGE_TYPES.CUSTOM_RANGE) {
    const { start, end } = getActiveDateRange(range, new Date());
    return [start, end];
  }
  if (from && to) return [new Date(from * 1000), new Date(to * 1000)];
  return null;
};
